import { createContext, useContext, useMemo } from 'react';

const SiteContext = createContext();

const defaultSiteMeta = {
  siteName: 'myfashiondeals.online',
  firebaseSiteDocId: 'myfashiondeals.online',
  orderPrefix: 'MFD',
  address: {
    street: '88 Howard Street',
    city: 'San Francisco',
    state: 'CA',
    zip: '94105',
    country: 'USA',
  },
  email: 'hello@myfashiondeals.online',
  phone: '1-888-847-8200',
  tagline: 'Fashion deals that feel like a win.',
};

function resolveFirebaseSiteDocId(siteMeta) {
  const explicit = (siteMeta.firebaseSiteDocId || '').trim().toLowerCase().replace(/^www\./, '');
  if (explicit) return explicit;
  if (typeof window !== 'undefined') {
    const host = window.location.hostname?.toLowerCase() || '';
    const withoutWww = host.startsWith('www.') ? host.slice(4) : host;
    if (withoutWww && withoutWww !== 'localhost' && withoutWww !== '127.0.0.1') {
      return withoutWww;
    }
  }
  return siteMeta.siteName.toLowerCase().replace(/\s/g, '');
}

export const SiteProvider = ({ children, meta = {} }) => {
  const siteMeta = { ...defaultSiteMeta, ...meta };

  const firebaseSiteDocId = useMemo(
    () => resolveFirebaseSiteDocId(siteMeta),
    [siteMeta.firebaseSiteDocId, siteMeta.siteName]
  );

  const value = {
    siteName: siteMeta.siteName,
    firebaseSiteDocId,
    orderPrefix: siteMeta.orderPrefix || siteMeta.siteName.replace(/[^a-zA-Z]/g, '').slice(0, 3).toUpperCase() || 'ORD',
    address: siteMeta.address,
    fullAddress: [
      siteMeta.address.street,
      `${siteMeta.address.city}, ${siteMeta.address.state} ${siteMeta.address.zip}`,
      siteMeta.address.country,
    ].join(', '),
    email: siteMeta.email,
    phone: siteMeta.phone,
    tagline: siteMeta.tagline,
  };

  return <SiteContext.Provider value={value}>{children}</SiteContext.Provider>;
};

export const useSite = () => {
  const context = useContext(SiteContext);
  if (!context) throw new Error('useSite must be used within a SiteProvider');
  return context;
};

export default SiteContext;
